import script from "./orderHistoryCont.vue?vue&type=script&setup=true&name=orderHistoryCont&lang=js"
export * from "./orderHistoryCont.vue?vue&type=script&setup=true&name=orderHistoryCont&lang=js"

const __exports__ = script;

export default __exports__